import {
  action,
  computed,
  Lambda,
  makeObservable,
  onBecomeObserved,
} from "mobx"

import { catchErrors, projectsApi } from "@src/shared/api"
import Collection from "@src/shared/classes/Collection/Collection"
import { loading } from "@src/shared/classes/utils/loading"
import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"

export class ProjectsCollection extends loading(["load"], Collection<any>) {
  constructor() {
    super()

    makeObservable(this, { load: action.bound, selectOptions: computed })

    const kill: Lambda = onBecomeObserved(this, "state", () => {
      kill()

      return this.load()
    })
  }

  async load() {
    if (this.isEmpty) {
      try {
        const { data: { data: response } = {} } = await projectsApi.getProjects(
          undefined,
          0,
          100,
        )

        if (response) {
          this.replace(response.data)
        }
      } catch (e: any) {
        catchErrors(e)
      }
    }
  }

  get selectOptions() {
    return this.items.map((i) => ({
      label: i.name,
      value: i.id,
    }))
  }
}

export default wrapSingleton(ProjectsCollection)
